(function() {
	//setup routing
	WebBaseAprovLV.RoutingTable = WebBaseAprovLV.RoutingTable || [];
	WebBaseAprovLV.RoutingTable = WebBaseAprovLV.RoutingTable.concat([
		{
			matches: /^home$/i,
			action: WebBaseAprovLV.renderHome
		},
		{
			matches: /^(suche|ricerca|chirida|search)$/i,
			action: WebBaseAprovLV.renderSearchPage
		},
		{
			matches: /^news$/i,
			action: (function() {
				return function(props) {
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderArticlePage(props);
					}
					return WebBaseAprovLV.renderArticlesPage(props);
				};
			})()
		},
		{
			matches: /^(anmeldung-newsabo-erfolgreich|registrazione-newsabo-successo|newsabo-subscription-success)$/i,
			action: WebBaseAprovLV.renderNewsletterSubscriptionSuccessPage
		},
		{
			matches: /^(projekte|progetti|proiec|projekte-archiv|progetti-archivio|proiec-archif)$/i,
			action: (function() {
				return function(props) {
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderProjectPage(props);
					}
					return WebBaseAprovLV.renderProjectsPage(props);
				};
			})()
		},
		{
			matches: /^(webcams)$/i,
			action: (function() {
				return function(props) {
					return WebBaseAprovLV.renderWebcamsPage(props);
				};
			})()
		},
		{
			matches: /^(klimadiagramme|diagrammi-del-clima|diagrams-climatics|climate-charts)$/i,
			action: (function() {
				return function(props) {
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderClimateChartsPage(props);
					}
					return WebBaseAprovLV.renderClimateChartsPage(props);
				};
			})()
		},
		{
			matches: /^(foehndiagramm|diagramma-del-foehn|diagram-dl-foehn|foehn-chart)$/i,
			action: (function() {
				return function(props) {
					return WebBaseAprovLV.renderGenericPage({
						context: props.context,
						options: { template: 'templates/foehn-charts.ejs.html', kkDepth: 1 }
					});
				};
			})()
		},
		{
			matches: /^(trend|tendenza)$/i,
			action: (function() {
				return function(props) {
					return WebBaseAprovLV.renderGenericPage({
						context: props.context,
						options: { template: 'templates/trend-charts.ejs.html', kkDepth: 1 }
					});
				};
			})()
		},
		{
			matches: /^(download-messdaten|download-dati|download-dac|download-data)$/i,
			action: (function() {
				return function(props) {
					return WebBaseAprovLV.renderGenericPage({
						context: props.context,
						options: { template: 'templates/download-daily-values.ejs.html', kkDepth: 2 }
					});
				};
			})()
		},
		{
			matches: /^(wetterberichte-pdf|bollettini-meteo-pdf|previjion-format-pdf|weather-bulletin-pdf)$/i,
			action: (function() {
				return function(props) {
					return WebBaseAprovLV.renderGenericPage({
						context: props.context,
						options: { template: 'templates/weather-download-pdf.ejs.html', kkDepth: 2 }
					});
				};
			})()
		},
		{
			matches: /^(widget)$/i,
			action: (function() {
				return function(props) {
					return WebBaseAprovLV.renderGenericPage({
						context: props.context,
						options: { template: 'templates/widget.ejs.html', kkDepth: 2 }
					});
				};
			})()
		},
		{
			matches: /^(meine-favoriten|i-miei-preferiti|mi-favoric|my-favourites)$/i,
			action: (function() {
				return function(props) {
					return WebBaseAprovLV.renderFavoritesPage({
						context: props.context,
						options: { template: 'templates/favorites.ejs.html', kkDepth: 2 }
					});
				};
			})()
		},
		{
			matches: /^(suedtirolwetter|meteo-alto-adige|meteo-suedtirol|south-tyrol-weather|gemeindewetter|meteo-comuni|temp-chemuns|municipality-weather)$/i,
			action: (function() {
				return function(props) {
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderMunicipalWeatherPage(props);
					}
					return WebBaseAprovLV.renderMunicipalWeatherMapPage(props);
				};
			})()
		},
		{
			matches: /^(bergwetter|tempo-in-montagna|temp-sa-mont|mountain-weather)$/i,
			action: (function() {
				return function(props) {
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderMountainWeatherPage(props);
					}
					return WebBaseAprovLV.renderMountainWeatherMapPage(props);
				};
			})()
		},
		{
			matches: /^(wetterstationen-tal|stazioni-meteo-valle|stazions-temp-valedes|weather-stations-valley|wetterstationen-berg|stazioni-meteo-montagna|stazions-temp-mont|weather-stations-mountain|pegelstationen|stazioni-idrometriche|stazions-ega|gauging-stations)$/i,
			action: (function() {
				return function(props) {
					props.scodeFilter = 'MS';
					if (props.context.params.page === 'wetterstationen-berg' || props.context.params.page === 'stazioni-meteo-montagna' || props.context.params.page === 'weather-stations-mountain' || props.context.params.page === 'stazions-temp-mont') {
						props.scodeFilter = 'WS.SF';
					}
					if (props.context.params.page === 'pegelstationen' || props.context.params.page === 'stazioni-idrometriche' || props.context.params.page === 'gauging-stations' || props.context.params.page === 'stazions-ega') {
						props.scodeFilter = 'PG';
					}
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderWeatherStationPage(props);
					}
					return WebBaseAprovLV.renderWeatherStationMapPage(props);
				};
			})()
		},
		{
			matches: /^pub(likationen|blicazioni|licaziuns|lications|licazions)$/i,
			action: WebBaseAprovLV.renderPublicationsPage
		},
		{
			matches: /^(veranstaltungen|eventi|events|manifestazioni|manifestaziuns|terminkalender|calendario-appuntamenti|termins)$/i,
			action: (function() {
				return function(props) {
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderAppointmentPage(props);
					}
					return WebBaseAprovLV.renderAppointmentsPage(props);
				};
			})()
		},
		{
			matches: /^sitemap$/i,
			action: WebBaseAprovLV.renderSitemapPage
		},
		{
			matches: /^(suche-fragen-und-antworten|ricerca-domande-e-risposte)$/i,
			action: (function() {
				return function(props) {
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderFaqPage(props);
					}
					return WebBaseAprovLV.renderFaqFacetsPage(props);
				};
			})()
		},
		{
			matches: /^cookie$/i,
			action: (function() {
				return function(props) {
					return WebBaseAprovLV.renderCookiePage(props)
					.then(function(props) {
						// global cookie text
						(function(ScwCookieIub) {
							var iub;
							if (null !== ScwCookieIub) {
								iub = ScwCookieIub.getInstance();
								iub.cookiePolicy(document.getElementById('js-iub-cookie-policy-text'), document.getElementById('js-iub-cookie-policy-services'));
							}
						})('object' === typeof ScwCookieIub ? ScwCookieIub : null);
						return props;
					});
				};
			})()
		},
		{
			matches: /^privacy$/i,
			action: (function() {
				return function(props) {
					return WebBaseAprovLV.renderPrivacyPage(props)
					.then(function(props) {
						// global privacy text
						(function(ScwCookieIub) {
							var iub;
							if (null !== ScwCookieIub) {
								iub = ScwCookieIub.getInstance();
								// iub.privacyPolicy(document.querySelector('#content .content_section .container div'));
								iub.privacyPolicy(document.getElementById('js-iub-privacy-policy-text'));
							}
						})('object' === typeof ScwCookieIub ? ScwCookieIub : null);
						return props;
					});
				};
			})()
		},
		{
			matches: /.*/,
			action: WebBaseAprovLV.renderGenericPage
		}
	]);
})();
